/**
 * Labstep
 *
 * @module ProtocolTimer/Action/Create/Form
 * @desc ProtocolTimer create action with form
 */

import { EntityActionCreateModal } from 'labstep-web/components/Entity/Action/Create/Modal';
import { actionText } from 'labstep-web/components/ProtocolTimer/Action/Create';
import { ProtocolTimerFormCreate } from 'labstep-web/components/ProtocolTimer/Form/Create';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { enhanceOptions } from 'labstep-web/services/utils.service';
import type React from 'react';
import type { IProtocolTimerActionCreateFormProps } from './types';

export const ProtocolTimerActionCreateForm: React.FC<
  IProtocolTimerActionCreateFormProps
> = ({
  protocol,
  viewComponent,
  actionComponentProps,
  defaultValues,
  options,
  modalProps,
}) => (
  <EntityActionCreateModal
    header={actionText}
    parent={protocol}
    entityName="protocol_timer"
    viewComponent={
      viewComponent ||
      (({ toggleModal }) => (
        <ActionComponent
          dataCy="components/ProtocolTimer/Action/Create"
          type="button"
          text={actionText}
          {...actionComponentProps}
          onClick={toggleModal}
        />
      ))
    }
    content={({ toggleModal }) => (
      <ProtocolTimerFormCreate
        defaultValues={defaultValues}
        protocol={protocol}
        options={enhanceOptions({
          options,
          onSuccess: toggleModal,
        })}
      />
    )}
    {...modalProps}
  />
);
